/**
 * Einblenden beim Scrollen: Elemente mit [data-pa-reveal] bekommen .is-in, sobald sie ins Bild kommen.
 * Verzögerung je Element über --d (Stufe 0, 1, 2 …), gesetzt im Markup. Einmalig, danach nicht mehr beobachtet.
 * Ohne IntersectionObserver oder bei „weniger Bewegung“ sofort sichtbar.
 */
import { qsa } from '../utils/dom.js';

export function init() {
	const items = qsa('[data-pa-reveal]');
	if (!items.length) return;

	if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
		items.forEach((el) => el.classList.add('is-in'));
		return;
	}

	const io = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) return;
			entry.target.classList.add('is-in');
			io.unobserve(entry.target);
		});
	}, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });

	items.forEach((el) => io.observe(el));
}
